// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "label-CKCZU";
var _3 = "labelContent-1om14";
var _4 = "input-iZLH7";
var _5 = "icon-3VWXo";
var _6 = "addIcon-rcMGS";
var _7 = "link-rvXp4";
var _8 = "addedIcon-2tyOJ";
var _9 = "removeIcon-3UH3-";
export { _1 as "__esModule", _2 as "label", _3 as "labelContent", _4 as "input", _5 as "icon", _6 as "addIcon", _7 as "link", _8 as "addedIcon", _9 as "removeIcon" }
export default { "__esModule": _1, "label": _2, "labelContent": _3, "input": _4, "icon": _5, "addIcon": _6, "link": _7, "addedIcon": _8, "removeIcon": _9 }
